import vm from '@/main'  ///导入VUE实例
import store from "store/index"; ///导入公共仓库


/**  下发配置通用接口入参说明
 * PRODUCT_01("01", "四路通断"), PRODUCT_02("02", "两路调光"), PRODUCT_03("03", "四键面板"), 
PRODUCT_04("04", "四路干接点安防模块"), PRODUCT_05("05", "感应器"), PRODUCT_06("06", "杜亚开合窗帘"), 
PRODUCT_07("07", "豪力士指纹门锁"), PRODUCT_08("08","modbus协议空调"), PRODUCT_09("09", "八键面板"), 
PRODUCT_10("010", "丙申开合窗帘"), PRODUCT_11("011", "萤石云监控"), PRODUCT_12("012", "音乐"), 
PRODUCT_13("013", "安防控制"), PRODUCT_14("014", "F路调光"), PRODUCT_15("015", "A0电机控制"),
PRODUCT_16("016", "三合一八键环境面板"),PRODUCT_17("017", "A地暖控制"), PRODUCT_18("018", "A新风控制"), 
PRODUCT_19("019", "环境探测器"), PRODUCT_20("020", "F键面板"),PRODUCT_21("021", "F路通断"),
PRODUCT_22("022", "A定时控制"), PRODUCT_23("023", "F路影视控制"), PRODUCT_24("024", "A音乐控制"),
PRODUCT_25("025", "F双色控制"), PRODUCT_26("026", "F三色控制"), PRODUCT_27("027", "W1智能插座"),
PRODUCT_28("028", "W2智能插座"),PRODUCT_99("099", "子场景")
//代号 20231207-1
"048" 1路组通断,  "049"  1路组调光  "050" 1路组双色调光 "051" 1路组三色调光

010:deviceNo地址
06:deviceNo地址
015:deviceNo地址
08:deviceNo=受控设备地址gatewayNo=转接设备地址
017:deviceNo=受控设备地址gatewayNo=转接设备地址
018:deviceNo=受控设备地址gatewayNo=转接设备地址
022:businessId1=定时状态0:关1:开 businessId2:时间(12:17) businessId3:重复设置(1,2,3,4,5) businessId4:场景id
024:deviceNo=受控设备地址gatewayNo=转接设备地址
016:businessId1=空调对象id businessId2:地暖对象id businessId3:新风对象id businessId4:环境探测对象id [选择不设置时传0 默认传空]
buttonCode:以下类型设备毕传
BUTTON_01("1", "单场景"), BUTTON_02("2", "双场景"), 
BUTTON_03("3", "通断"), BUTTON_04("4", "调光"), 
BUTTON_05("5", "电机")
03:
05:
07:
09:
013:
020
 */
 
////设置页面下发配置(通用) 公共的请求方法
const configPageDataRequest = (tempData) => {

    return new Promise((resolve, reject) => {

        vm.$request({
            method: "post",
            url: "/device/updateDeviceBottom",
            data: tempData
        })
            .then(res => {
                if (res.data.code != 0) {
                    vm.$showTipsToast(3, res.data.message);
                    ////说明信息填写错误,控制失败了，
                    return;
                } else {
                    ////、控制成功了
                    //////返回服务器数据
                    // console.log(res.data.data)
                    resolve(res.data.data)
                }
            })
            .catch(error => {
                console.log(error);
                reject(error);
            });


        // resolve(a1);////成功返回的对象
        // reject(a2);  ////失败返回的对象

    });
}


















export {
    configPageDataRequest

}